import React from 'react';

const RatingSummary = ({ productID }) => {
  return (
    <div id="bv-rating">
      <div data-bv-show="rating_summary" data-bv-product-id={productID} />
    </div>
  );
};

export default RatingSummary;
